
const haiso_c_observer = new MutationObserver(haisocfHandleFormChange);
//日付非表示商品タグ名
const haiso_c_tagName = "配送指定不可";
//アプリ設定画面上　日付指定属性名　時間帯指定属性名
const haiso_c_attributeKeys = ['delivery_date', 'delivery_time'];

function haisocfNodeOrChildrenHasCartItems(node) {
  if (node.nodeType !== 1) return false;

 
  if (node.classList && [...node.classList].some(c => c.includes("cart-item__column"))) {
    return true;
  }
  
  if (node.querySelector?.("cart-item__column")) {
    return true;
  }

  if (typeof node.innerHTML === "string" && node.innerHTML.includes("cart-item__column")) {
    return true;
  }

}

function haisocfHandleFormChange(mutationsList, observer) {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList') {

      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {  // element node
          if (node.id === "haisosm_et" || node.querySelector?.("#haisosm_et")) {
            haisocfCheckCartItemsForTag(haiso_c_tagName);
          }

          if (haisocfNodeOrChildrenHasCartItems(node)) {
            haisocfCheckCartItemsForTag(haiso_c_tagName);
          }
        }
      });


      mutation.removedNodes.forEach(node => {
       if (haisocfNodeOrChildrenHasCartItems(node)) {
          haisocfCheckCartItemsForTag(haiso_c_tagName);
        }
      });


    }
  }
}
haiso_c_observer.observe(document.body,  { childList: true, subtree: true });

function haisocfCheckCartItemsForTag(tag) {

  var divElements = document.getElementsByClassName("item_tags");

  const haisoDivToHide = document.getElementById('haisosm_et');
  
     var hide = false;
  
  
    for (var i = 0; i < divElements.length; i++) {
      var divContent = divElements[i].innerHTML;

      if (divContent.length >0 && divContent.includes(tag)) {
              hide = true;
              break;
          }
      }

  if (hide) {
    haisoDivToHide.style.display = 'none';
          haisocfRemoveAttributesWithKeys();
  } else {
          haisoDivToHide.style.display = 'block';
  }
}

function haisocfRemoveAttributesWithKeys() {
  // Retrieve the current cart data
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
    .then(response => response.json())
    .then(data => {
      const cartAttributes = data.attributes;

      for (const key of haiso_c_attributeKeys) {
        if (cartAttributes[key]) {
          data.attributes[key] = ''
        };
      }


      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(data => {
          haisocfUpdateCurrentAtttibute();
        })
        .catch(error => {
          console.error('Error:', error);
        });
    })
    .catch(error => {
      console.error('Error:', error);
    });
}

function haisocfUpdateCurrentAtttibute() {

  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
    .then(response => response.json())
    .then(data => {

      const cartAttributes = data.attributes;
      for (const key of haiso_c_attributeKeys) {
        if (!cartAttributes[key]) {
          const inputElements = document.querySelectorAll(`input[name="attributes[${key}]"]`);
          inputElements.forEach(div => {
            div.value = ''
          });
          const selectElements = document.querySelectorAll(`select[name="attributes[${key}]"]`);
          selectElements.forEach(div => {
            div.value = ''
          });
        };
      }

    })
};

haisocfCheckCartItemsForTag(haiso_c_tagName);